import React from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from 'styled-components';
import Routes from '../__Routes';
import { AuthProvider } from '../../Context/hooks/auth';
import theme from '../../assets/theme';
import ToTop from '../../components/ToTop';

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <div className="App">
          <ToTop />
          <Switch>
            <Routes />
          </Switch>
          <ToastContainer />
        </div>
      </ThemeProvider>
    </AuthProvider>
  </BrowserRouter>
);

export default App;
